export const getSum = (list) => {
  let totalSum = 0
  for (let n = 0; n < list.length; n++) {
    totalSum = totalSum + list[n].finalAmount
  }
  return Math.round(totalSum)
}
